<template>
  <ConfirmationModalRoot v-model="isOpen">
    <template #default>
      <ConfirmationModalTitle>
        {{ title }}
      </ConfirmationModalTitle>

      <slot></slot>
    </template>

    <template #actions>
      <ButtonV2 variant="primary" size="sm" @click="confirm">
        {{ confirmLabel }}
      </ButtonV2>
      <ButtonV2 variant="subtle" size="sm" @click="close">
        {{ $t("channel.modal.cancel") }}
      </ButtonV2>
    </template>
  </ConfirmationModalRoot>
</template>

<script setup lang="ts">
import ConfirmationModalRoot from "@/components/ui/modal/confirmation-modal/confirmation-modal-root.vue";
import ConfirmationModalTitle from "@/components/ui/modal/confirmation-modal/confirmation-modal-title.vue";
import ButtonV2 from "@/components/ui/button/button-v2.vue";

const isOpen = defineModel<boolean>({ required: true });

defineProps<{
  title: string;
  confirmLabel: string;
}>();

const emits = defineEmits<{
  confirm: [];
  cancel: [];
}>();

function confirm() {
  emits("confirm");
  isOpen.value = false;
}

function close() {
  emits("cancel");
  isOpen.value = false;
}
</script>
